import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0, 0],
        rowSpan: {
          "0:1": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide02-source-image01.svg`,
                    styles: {
                      height: "250px",
                    },
                  },
                },
              },
            },
            {
              variant: "layout",
              data: {
                type: "layer",
                options: {
                  layerStyles: [
                    null,
                    {
                      top: "-150px",
                      left: "200px",
                    },
                  ],
                  components: [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/02/case01/slide02-source-image02.svg`,
                            styles: {
                              height: "455px",
                              width: "662px",
                            },
                          },
                        },
                      },
                    },
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioButton",
                          options: {
                            url: "",
                            text: "sound sample",
                            icon: "cis-volume-high",
                            theme: "primary",
                            shape: "round",
                          },
                        },
                      },
                    },
                  ],
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "Before any measurements are performed, all relevant operating states of the appliance should be identified. In the portraited example, these could be water heating, coffee grinding, brewing and cleaning / grounds disposal. The appliance under test should also be operated under realistic conditions, for example, the grinding stage of the coffee machine will sound quite differently if no coffee beans are placed inside the hopper. The use of additional sensors might be considered in order to identify the causes or sources of unpleasant sound.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 400,
                    },
                  },
                },
                styles: {
                  width: "93%",
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
